export const tablet = '699px'
export const desktop = '899px'
